
































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import ShippingCompany from '@/api/shipping/index'
@Component({
  components: {}
})
export default class ShippingList extends AbpBase {
  columns: any[] = [
    {
      title: '模板名称',
      key: 'name',
      align: 'center'
    },
    {
      title: '计算方式',
      slot: 'calcType',
      align: 'center'
    },
    {
      title: '计算规则',
      slot: 'calcRules',
      align: 'center'
    },
    {
      title: '适用区域',
      slot: 'areas',
      align: 'center'
    },
    {
      title: '是否包邮',
      slot: 'isFree',
      align: 'center'
    },
    {
      title: '是否启用',
      slot: 'published',
      width: 100,
      align: 'center'
    },
    {
      title: '操作',
      slot: 'action',
      width: 170,
      align: 'center'
    }
  ]
  loading: boolean = false
  tableData: any[] = []
  page = {
    totalCount: 0,
    currentPage: 1,
    maxResultCount: 10
  }

  created() {
    this.getShippingTemplateList()
  }

  /**
   * 获取运费模板列表
   */
  getShippingTemplateList() {
    let id = this.$route.query['id']
    if (id) {
      this.loading = true
      ShippingCompany.getShippingTemplateList(
        id.toString(),
        this.page.maxResultCount,
        this.page.currentPage
      )
        .then(res => {
          this.page.totalCount = res.data.totalCount
          this.tableData = res.data.items
          this.loading = false
        })
        .catch(err => {
          this.loading = false
        })
    }
  }

  /**
   * 新增/编辑
   */
  editFn(id?) {
    let query = {
      companyId: this.$route.query['id'],
    }
    if(id) {
      query['templateId'] = id
    }
    this.$router.push({
      name: 'editShippingTemplate',
      query: query
    })
  }

  /**
   * 删除运费模板
   */
  deleteShippingTemplate(id) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.loading = true
        let companyId = this.$route.query['id']
        ShippingCompany.deleteShippingTemplate(companyId.toString(), id).then(res => {
          this.loading = false
          this.getShippingTemplateList()
        }).catch(err => {
          this.loading = false
        })
      }
    })
  }

  changePage(e) {
    this.page.currentPage = e
    this.getShippingTemplateList()
  }
  pageSizeChange(e) {
    this.page.maxResultCount = e
    this.page.currentPage = 1
    this.getShippingTemplateList()
  }
}
